import Vue from 'vue';

Vue.mixin({
  data() {
    return {
      limitSelectMessage: 'Only up to 200 items can be added to the queue at a time. Please limit your results to 200 items or use the Download All feature.',
      trialAccessMessage: 'Downloads are not available with trial access. Please contact your sales representative for more information.',
      noAuthMessage: 'Please create an Authentication Method to enable the ability to download Custom or Customized Content.',
    };
  },
  computed: {
    limitActivationsMessage() {
      const aa = this.$store.getters.activationsAllowed;
      return `Sorry, currently ${aa} activation${aa === 1 ? '' : 's'} remain`;
    },
    isIE() {
      return !(window.ActiveXObject) && 'ActiveXObject' in window;
    },
    isEdge() {
      return window.navigator.userAgent.indexOf('Edge/') > -1;
    },
  },
  methods: {
    deepClone(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    showModals(selector) {
      // this determines if browser is IE11
      if (this.isIE) {
        $(selector).modal('setting', 'duration', '100');
      }
      $(selector).modal('show');
    },
  },
});
